var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiderMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 32.5,
    viewBox: "0 0 26 32.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "where_to_vote_FILL1_wght400_GRAD0_opsz48",
    d: "M21,36.5a54.021,54.021,0,0,1-9.77-10.339Q8,21.387,8,17.325a12.567,12.567,0,0,1,3.92-9.709,13.208,13.208,0,0,1,18.159,0A12.567,12.567,0,0,1,34,17.325q0,4.063-3.23,8.836A54.021,54.021,0,0,1,21,36.5Z",
    transform: "translate(-7.5 -3) scale(0.94)",
    fill: "#198b8d",
    stroke: "#198b8d",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.5 4) scale(0.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_439",
    "data-name": "Tracciato 439",
    d: "M728.736,105.021a2.03,2.03,0,0,0,4.048.289Z",
    transform: "translate(-714.818 -103.016)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_440",
    "data-name": "Tracciato 440",
    d: "M736.425,5.507h0a.169.169,0,0,0-.157-.181l-1.116-.08A2.028,2.028,0,0,0,731.2,5.3l.958.068,4.086.291a.169.169,0,0,0,.181-.157",
    transform: "translate(-717.239 -3.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_441",
    "data-name": "Tracciato 441",
    d: "M5.306,791.949a5.306,5.306,0,1,1,5.305-5.306,5.312,5.312,0,0,1-5.305,5.306m0-9.6A4.292,4.292,0,1,0,9.6,786.644a4.3,4.3,0,0,0-4.292-4.292",
    transform: "translate(0 -766.419)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_442",
    "data-name": "Tracciato 442",
    d: "M863.6,791.949a5.306,5.306,0,1,1,5.306-5.306,5.312,5.312,0,0,1-5.306,5.306m0-9.6a4.292,4.292,0,1,0,4.292,4.292,4.3,4.3,0,0,0-4.292-4.292",
    transform: "translate(-841.909 -766.419)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_443",
    "data-name": "Tracciato 443",
    d: "M439.107,204.084l3.139,1.178a.81.81,0,0,1-.553,1.522l-3.549-1.248-2.043-2.592-3.175,4.352,2.4,4.064,1.22,5.6a1.081,1.081,0,0,1-2.109.481L433.19,212.2l-2.922-3.961a2.269,2.269,0,0,1-.028-2.655l3.377-4.787a1.952,1.952,0,0,1,3.195.007Z",
    transform: "translate(-421.618 -196.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_444",
    "data-name": "Tracciato 444",
    d: "M232.954,1013.4a.891.891,0,1,1-.891-.891.891.891,0,0,1,.891.891",
    transform: "translate(-226.757 -993.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_445",
    "data-name": "Tracciato 445",
    d: "M1091.251,1013.4a.891.891,0,1,1-.891-.891.891.891,0,0,1,.891.891",
    transform: "translate(-1068.665 -993.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2769",
    "data-name": "Rettangolo 2769",
    width: 0.71,
    height: 11.138,
    transform: "translate(18.782 9.468) rotate(-13.323)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_446",
    "data-name": "Tracciato 446",
    d: "M253.267,598.573l-8.869-.515,5.56-8.338,9.387-.963.072.706-9.055.929-4.688,7.029,7.268.422,6.387-7.915.552.446Z",
    transform: "translate(-239.732 -577.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_447",
    "data-name": "Tracciato 447",
    d: "M204.979,9.1,201.773,6.84a.636.636,0,0,1-.154-.886l4-5.684A.636.636,0,0,1,206.5.116l3.206,2.255a.636.636,0,0,1,.154.886l-4,5.684a.636.636,0,0,1-.886.154",
    transform: "translate(-197.655 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiderMarker);
export default __webpack_public_path__ + "static/media/rider-marker.4e3fb64b7de69ed09354aab0cb0ed6bc.svg";
export { ForwardRef as ReactComponent };